import { skipAnalyticsLogging } from './trackingActions';
import transformData, { transformPageData, getEventName } from './transformTrackingData';
import { getLastPartFromUrl } from '../../utils/utils';
import { CART_URL } from '../constants';

const setDataLayer = ({ initialConfigs, data, type, eventsHistory }) => {
  if (process.browser) {
    if (typeof window.watersDataLayer === 'undefined') {
      window.watersDataLayer = [];
    }

    const skipEventLogging = skipAnalyticsLogging.includes(type);
    const isCartPage = getLastPartFromUrl(window.location.pathname) === CART_URL;

    if ((isCartPage && eventsHistory.length <= 1) || !skipEventLogging) {
      const transformedData = transformData(data, type);
      const config = transformPageData(data, type, initialConfigs);
      window.watersDataLayer.push({
        ...config,
        ...transformedData,
        event: getEventName(data, type),
      });
    }
  }
};

export default setDataLayer;
